import { connect } from 'react-redux';
import _isEmpty from 'lodash.isempty';
// Actions
import { fetchLists } from '../actions/actions_lists';
import { fetchUser } from '../actions/actions_user';
// Components
import SingleChecklistView from '../views/SingleChecklistView';


// Map Redux state to component props
// Second arguments = "own props" that are passed to the connected component
const mapStateToProps = (state, ownProps) => {
    // only work with a particular list
    let listId = ownProps.match.params.id;
    return {
        list: state.lists[listId.toLowerCase()],
        user: state.user,
        loading: (_isEmpty(state.lists)) ? true : false,
        error: state.lists.error ? true : false,
        userLoaded: _isEmpty(state.user.userId) ? false : true,
        showMsgStarredMaximum: state.view.showMsgStarredMaximum
    }
}


// Connect component
const ContaierSingleChecklistView = connect(
    mapStateToProps,
    { fetchLists, fetchUser }
)(SingleChecklistView)


export default ContaierSingleChecklistView



// WEBPACK FOOTER //
// ./src/containers/ContainerSingleChecklistView.js